//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025, 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import type { PlanReferent } from '../../../types/conversationHistory';

/**
 * The domains a plan is approved to act in: the domains of its own items,
 * each once, in the order they first appear. A plan has no separate
 * domain list, so this is the whole scope the approver is ratifying.
 */
export const planDomains = (
  referents: Pick<PlanReferent, 'domain'>[] | undefined,
): string[] =>
  Array.from(
    new Set((referents ?? []).map((ref) => ref.domain).filter(Boolean)),
  );
